<template>
  <span class="ai-visibility-panel-badge">
    <slot />
  </span>
</template>

<script>
export default {
  name: 'PanelBadge',
}
</script>

<style lang="scss" scoped>

.ai-visibility-panel-badge {
  display: inline-flex;
  min-height: 24px;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background: var(--v-link3Color-base);
  color: var(--v-whiteColor-base);
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  padding: 4px 8px;
  height: fit-content;
}
</style>
